import { render, staticRenderFns } from "./addrole.vue?vue&type=template&id=7874cee5&scoped=true"
import script from "./addrole.vue?vue&type=script&lang=js"
export * from "./addrole.vue?vue&type=script&lang=js"
import style0 from "./addrole.vue?vue&type=style&index=0&id=7874cee5&prod&lang=less&scoped=true"
import style1 from "./addrole.vue?vue&type=style&index=1&id=7874cee5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7874cee5",
  null
  
)

export default component.exports